import React, { useEffect, useState } from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { WhatIs } from './components/WhatIs';
import { Process } from './components/Process';
import { HowItWorksForYou } from './components/HowItWorksForYou';
import { ForWho } from './components/ForWho';
import { PoC } from './components/PoC';
import { Booking } from './components/Booking';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { SEO } from './components/SEO';
export function App() {
  const {
    scrollYProgress
  } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });
  return <div className="font-sans antialiased overflow-x-hidden min-h-screen flex flex-col" data-id="element-0">
      <SEO data-id="element-1" />

      {/* Skip-to-content link voor toegankelijkheid + SEO */}
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[100] focus:bg-brand-primary focus:text-white focus:px-4 focus:py-2 focus:rounded-lg focus:font-bold" data-id="element-2">
        Direct naar de inhoud
      </a>

      {/* Scroll Progress Bar */}
      <motion.div className="scroll-progress" style={{
      scaleX
    }} data-id="element-3" />

      <Nav data-id="element-4" />
      <main id="main" className="flex-grow" role="main" data-id="element-5">
        <Hero data-id="element-6" />
        <PainPoints data-id="element-7" />
        <WhatIs data-id="element-8" />
        <Process data-id="element-9" />
        <HowItWorksForYou data-id="element-10" />
        <ForWho data-id="element-11" />
        <PoC data-id="element-12" />
        <Booking data-id="element-13" />
        <FAQ data-id="element-14" />
      </main>
      <Footer data-id="element-15" />
    </div>;
}